export const parseParamsStr = (paramsStr: string | null | undefined) => {
    return (paramsStr ?? "")
        .split(",")
        .filter(Boolean)
        .reduce(
            (obj, pair) => {
                const di = pair.indexOf("=");

                if (di === -1) {
                    obj[pair] = "";

                    return obj;
                }

                const k = pair.slice(0, di);
                const v = pair.slice(di + 1);

                obj[k] = v;

                return obj;
            },
            {} as Record<string, string>,
        );
};
